// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"16813d01","453":"0351edcc","633":"8a7a1627"}[chunkId] + ".chunk.js";
};